import { ReactNode } from 'react';
import classNames from 'classnames';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
import { Snackbar } from '../snackbar';
interface Props {
  children: ReactNode;
  tooltipText: ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  parentClassName?: string;
  className?: string;
  hasIcon?: boolean;
}
function Tooltip({
  children,
  tooltipText,
  position = 'bottom',
  parentClassName,
  className,
  hasIcon = false
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  return <div className={classNames('group flex', parentClassName)} data-sentry-component="Tooltip" data-sentry-source-file="index.tsx">
            {children}

            <Snackbar size={isMobile ? 'medium' : 'large'} state='info' style='filled' type='text' hasIcon={hasIcon} className={classNames('!absolute z-10 scale-0 group-hover:scale-100', {
      'left-1/2 top-full -translate-x-1/2': position === 'bottom'
    }, className, {
      'bottom-full left-1/2 mb-1 -translate-x-1/2': position === 'top'
    }, {
      'left-full top-1/2 ml-1 -translate-y-1/2': position === 'right'
    }, {
      'right-full top-1/2 mr-1 -translate-y-1/2': position === 'left'
    })} data-sentry-element="Snackbar" data-sentry-source-file="index.tsx">
                {tooltipText}
            </Snackbar>
        </div>;
}
export default Tooltip;